import { render, staticRenderFns } from "./cultures.vue?vue&type=template&id=65af1b60&scoped=true"
import script from "./cultures.vue?vue&type=script&lang=js"
export * from "./cultures.vue?vue&type=script&lang=js"
import style0 from "./cultures.vue?vue&type=style&index=0&id=65af1b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65af1b60",
  null
  
)

export default component.exports